import React, { useContext } from 'react';
import { WalletContext } from '../context/WalletContext';
import Wallet from './Wallet';
import '../styles/navbar.css';

const Navbar = () => {
  const { publicKey, balance, error } = useContext(WalletContext);

  return (
    <nav className="navbar">
      <div className="navbar-brand">SolDice</div>
      <div className="navbar-menu">
        <div className="navbar-end">
          <div className="navbar-item">
            <Wallet />
            {publicKey && (
              <span className="balance">Balance: {balance} SOL</span>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;